import Component from '../inherited/Component'
import rivets from 'rivets'
import Helpers from '../lib/Helpers'
import axios from 'axios'

class FragranceFinder extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._jsonElem = this._elem.querySelector('[data-fragrance-finder-json]')
    this._data = JSON.parse(this._jsonElem.innerHTML)
    this._jquery = window.$ || null
    this._collectionUrl = `${this._ctx.getState().rootURL}/collections/${this._data.collection.handle}`
    this._recommendationsArea = this._elem.querySelector('[data-fragrance-finder-recs]')
    this._addToCartArea = this._elem.querySelector('[data-fragrance-finder-atc]')
  }

  async mount () {
    this._data = await this.prepareData(this._data)

    this._binders()
    this._render()
    this._scrollListener()
  }

  async prepareData (data) {

    let filter_data = await axios.get(`${this._collectionUrl}?view=json`)
    data.all_filters = filter_data.data.filters

    for(let [index, step] of data.steps.entries()) {
        step.index = index + 1
        step.selected_values = []

        if(step.type === 'filter') {
          let filterFound = false
          for(let filter of data.all_filters) {
            let filterHandle = filter.name.split('.').pop();
            if (filterHandle == step.filter) {
              step.filter = filter;
              filterFound = true;
            }

            // Filter out values containing underscore
            filter.values = filter.values.filter(value => !value.label.includes('_'));

            for (let value of filter.values) {
              let valueImage = data.images.find(image => image.filter == value.label);
              if (valueImage) {
                value.image = valueImage.image;
                value.color = valueImage.color;
              }
              value.label = value.label.replace(' notes', '');
            }
          }
          if(!filterFound) {
            data.steps = data.steps.filter(data_step => data_step != step)
          }

          // auto-select the middle value
          console.error(step)
          if(!step.filter.values) {
            continue
          }
          let middleValue = Math.ceil(step.filter.values.length / 2) - 1
          step.selected_values.push(step.filter.values[middleValue])
          step.image = step.filter.values[middleValue].image
          step.color = step.filter.values[middleValue].color
        }
    }

    data.selected_filters = []
    data.current_step_index = 0
    data.step_count = data.steps.length
    data.is_complete = false

    return data
  }

  _render () {
    console.log('fragrance finder', this._data)
    this._bind = rivets.bind(this._elem, this._getModel())
    this._elem.classList.add('rendered')
  }

  _scrollListener () {
    for(let [index, step] of this._data.steps.entries()) {
      let stepElem = this._elem.querySelectorAll('[data-fragrance-finder-step]')[index]
      if(stepElem.querySelector('.r--fragrance-finder-scroll')) {
        let scrollIdleTime = 50
        let lastScroll = scrollIdleTime
        let area = stepElem.querySelector('.r--fragrance-finder-scroll')
        area.addEventListener('wheel', (e) => {
          e.preventDefault()
          let delta = e.deltaY
          let timeNow = performance.now()
          this._bind.models.step = step
          if (delta > 0 && (timeNow > (lastScroll + scrollIdleTime)) ) {
              this._bind.models.controller.nextValue(e, this._bind.models)
          } else if (delta < 0 && (timeNow > (lastScroll + scrollIdleTime))) {
              this._bind.models.controller.previousValue(e, this._bind.models)
          }
          lastScroll = timeNow
        })
      }
    }
  }

  _getModel () {
    return {
      data: this._data,
      controller: {
        reset: async (e, model) => {
            model.data.current_step_index = 1
            this._elem.scrollIntoView({
              'top': 0,
              'behavior': 'smooth'
            })
        },
        previousStep: async (e, model) => {
            model.data.current_step_index = model.data.current_step_index - 1
        },
        goToStart: async (e, model) => {
            model.data.current_step_index = 0
        },
        goToStep: async (e, model) => {
            model.data.current_step_index = model.step.index
            this._elem.scrollIntoView({
              'top': 0,
              'behavior': 'smooth'
            })
        },
        changeStep: async (e, model) => {
            if(model.data.current_step_index > 0) {
                model.data.current_step_index = model.data.current_step_index + 1
            } else {
                model.data.current_step = model.data.steps[0]
                model.data.current_step_index = 1
            }
            this._elem.scrollIntoView({
              'top': 0,
              'behavior': 'smooth'
            })
        },
        selectValue: async (e, model) => {
          const selectedIndex = model.step.selected_values.findIndex(v => v.value === model.value.value);

          if (selectedIndex !== -1) {
            // Value already selected -> proceed to next step if min_limit met
            const meetsMin = model.step.selected_values.length >= model.step.min_limit;
            if (meetsMin && model.step.index < model.data.step_count) {
              model.data.current_step_index += 1;
            }
          } else {
            // Select new value
            if (model.step.limit > 1) {
              model.step.selected_values = [...model.step.selected_values, model.value];
              if (model.step.selected_values.length > model.step.limit) {
                model.step.selected_values.shift(); // enforce max limit
              }
            } else {
              model.step.selected_values = [model.value];
            }
            if (model.value.image) {
              model.step.image = model.value.image;
            }

            if (model.value.color) {
              model.step.color = model.value.color;
            }
          }
        },
        previousValue: async (e, model) => {

            let currentValue = model.step.selected_values[0]
            let currentValueIndex
            for(let [index, value] of model.step.filter.values.entries()) {
                if(value == currentValue) {
                    currentValueIndex = index
                    break
                }
            }

            let newIndex = currentValueIndex - 1
            if(newIndex < 0) {
                newIndex = model.step.filter.values.length - 1
            }

            model.step.selected_values.push(model.step.filter.values[newIndex])

            if(model.step.selected_values.length > model.step.limit) {
                model.step.selected_values.shift()
            }
        },
        nextValue: async (e, model) => {

            let lastValue = model.step.selected_values[model.step.selected_values.length - 1]
            let lastValueIndex
            for(let [index, value] of model.step.filter.values.entries()) {
                if(value == lastValue) {
                    lastValueIndex = index
                    break
                }
            }

            let newIndex = lastValueIndex + 1
            if(newIndex > (model.step.filter.values.length - 1)) {
                newIndex = 0
            }

            model.step.selected_values.push(model.step.filter.values[newIndex])

            if(model.step.selected_values.length > model.step.limit) {
                model.step.selected_values.shift()
            }

        },
        getRecommendations: async (e, model) => {
          let filtersToApply = [];

          for (let step of this._data.steps) {
            if (step.selected_values.length > 0) {
              for (let value of step.selected_values) {
                let filterUrl = `${step.filter.name}=${encodeURIComponent(value.value)}`;
                filtersToApply.push(filterUrl);
              }
            }
          }

          const baseUrl = `${this._collectionUrl}?limit=50&view=products&info_only=true&product=${model.data.product}&priority=${model.data.priority_tag}`;
          const filterUrl = `${this._collectionUrl}?${filtersToApply.join('&')}&view=products&limit=50&info_only=true&product=${model.data.product}&priority=${model.data.priority_tag}`;

          const filterPage = await axios.get(filterUrl, { responseType: 'document' });
          const parser = new DOMParser();
          const html = parser.parseFromString(filterPage.data.body.innerHTML, 'text/html');
          const recommendationsHtml = html.querySelector('[data-products]');
          let foundProductForm = html.querySelector('product-form');
          let filteredCards = recommendationsHtml ? [...recommendationsHtml.querySelectorAll('.product-grid-item')] : [];

          console.log('[DEBUG] Filtered productCards:', filteredCards.length);

          // Get fallback products
          const fallbackPage = await axios.get(baseUrl, { responseType: 'document' });
          const fallbackHtml = new DOMParser().parseFromString(fallbackPage.data.body.innerHTML, 'text/html');
          const fallbackRecommendationsHtml = fallbackHtml.querySelector('[data-products]');
          const fallbackCards = fallbackRecommendationsHtml ? [...fallbackRecommendationsHtml.querySelectorAll('.product-grid-item')] : [];
          const fallbackProductForm = fallbackHtml.querySelector('product-form');

          if (!foundProductForm && fallbackProductForm) {
            foundProductForm = fallbackProductForm;
          }

          const existingHandles = new Set(filteredCards.map(card => card.getAttribute('data-handle')));
          const additionalCards = fallbackCards.filter(card => {
            const handle = card.getAttribute('data-handle');
            return handle && !existingHandles.has(handle);
          });

          const allCards = [...filteredCards, ...additionalCards];
          console.log('[DEBUG] Combined productCards after fallback:', allCards.length);

          if (!allCards.length) {
            console.error('No products found.');
            return;
          }

          const notesStep = this._data.steps[2];
          const selectedNotes = notesStep.selected_values.map(val => val.value);

          const scoredProducts = filteredCards.map(card => {
            const rawNotes = card.getAttribute('data-parfume-notes');
            if (!rawNotes) return null;

            const notesArray = rawNotes.split(',').filter(Boolean);
            const notesRanking = notesArray.map(noteStr => {
              const parts = noteStr.split('_');
              return {
                note: parts[0],
                rank: parts[1] ? parseInt(parts[1], 10) : 999
              };
            });

            const ranks = [];
            for (const selectedNote of selectedNotes) {
              const match = notesRanking.find(n => n.note.toLowerCase() === selectedNote.toLowerCase());
              if (match) ranks.push(match.rank);
            }

            if (ranks.length === 0) return null;

            return {
              card,
              score: Math.min(...ranks)
            };
          });

          console.log('[DEBUG] Scored products (filtered only):', scoredProducts.length);

          let validMatches = scoredProducts.filter(Boolean).sort((a, b) => a.score - b.score);
          console.log('[DEBUG] Valid matches after scoring:', validMatches.length);

          // Add fallback cards without scoring
          const fallbackToAdd = additionalCards.map(card => ({ card, score: 999 }));
          validMatches = [...validMatches, ...fallbackToAdd].slice(0, 5);

          console.log('[DEBUG] Final cards before slicing to 5:', validMatches.length);
          console.log('[DEBUG] Final 5 handles to render:', validMatches.map(v => v.card.getAttribute('data-handle')));

          // Render
          this._recommendationsArea.innerHTML = '';
          this._addToCartArea.innerHTML = '';

          const gridWrapper = document.createElement('div');
          gridWrapper.className = 'product-grid';
          gridWrapper.setAttribute('data-products', '');
          validMatches.slice(0, 5).forEach(item => gridWrapper.appendChild(item.card));
          this._recommendationsArea.appendChild(gridWrapper);

          if (foundProductForm) {
            this._addToCartArea.appendChild(foundProductForm);
            const sampleInputs = foundProductForm.querySelectorAll('input[name^="properties[Sample "]');
            sampleInputs.forEach((input, index) => {
              if (index >= 5) {
                input.parentElement.removeChild(input);
              }
            });
          }

          Helpers.nextFrame(() => {
            this._theme.mountComponents(this._recommendationsArea);
            this._theme.mountComponents(this._addToCartArea);
            this._ctx.emit('radiant--lazy-load-update');
          });

          model.data.current_step_index += 1;
        },
        isInfoStep: async (e, model) => {
          const step = model.data.steps[ model.data.current_step_index];
          return step.type === 'info';
        }
      }
    }
  }

  _binders () {
    rivets.formatters.getSrcSet = (src, size) => {
      return src ? `${Helpers.getSizedImageUrl(src, size)} 1x, ${Helpers.getSizedImageUrl(src, size + '@2x')} 2x` : ''
    }

    rivets.formatters.getSizedImage = (src, size) => {
      return src ? Helpers.getSizedImageUrl(src, size) : ''
    }

    rivets.formatters.toArr = (count) => {
      let result = []
      for (let i = 0; i < count; i++) {
        result.push(i)
      }
      return result
    }

    rivets.formatters.moneyWithFree = (value) => {
      return value > 0 ? Helpers.formatMoney(value, this._ctx.getState()) : this._ctx.getState().locale.free
    }

    rivets.formatters.money = (value) => {
      return Helpers.formatMoney(value, this._ctx.getState())
    }

    rivets.formatters.getProductCount = (products, product, variant) => {
      return products.filter(item => item.handle === product.handle && item.selected_variant && item.selected_variant.id === variant.id).length
    }

    rivets.formatters.getIndex = (arr, index) => {
      return arr[index]
    }

    rivets.formatters.length = (arr) => {
      return arr ? arr.length : 0
    }

    rivets.formatters.isComplete = (step) => {
      return step.selected_values.length === step.limit
    }

    rivets.formatters.getStepColor = (step) => {
        return step.selected_values[step.selected_values.length - 1].color
    }

    rivets.formatters.getSelectText = (step) => {
      const selected = Array.isArray(step.selected_values) ? step.selected_values.filter(Boolean) : [];
      const limit = step.limit || 1;
      return `${selected.length}/${limit}`;
    }

    rivets.formatters.handleize = (arr) => {
      return Helpers.handleize(arr)
    }

    rivets.formatters.eq = (val, val2) => {
      return val === val2
    }

    rivets.formatters.gt = (val, val2) => {
      return val > val2
    }

    rivets.formatters.lt = (val, val2) => {
      return val < val2
    }

    rivets.formatters.gte = (val, val2) => {
      return val >= val2
    }

    rivets.formatters.not = (val) => {
      return !val
    }

    rivets.formatters.isSelected = (value, selectedValues) => {
        return selectedValues.find(selectedValue => value === selectedValue)
    }

    rivets.formatters.isFinalStep = (index, steps) => {
        return index > steps.length
    }

    rivets.formatters.pluralize = (count, one, multiple) => {
      return count === 1 ? one : multiple
    }

    rivets.formatters.prepend = (one, two) => {
      return `${two}${one}`
    }

    rivets.formatters.minus = (a, b) => {
      return a - b

    }

    rivets.formatters.plus = (a, b) => {
      return a + b
    }
 
    rivets.formatters.toJson = (item) => {
      return JSON.stringify(item)
    }

    rivets.binders['set-class'] = function(el, value){
      if (el.classList.contains(value)) {
        el.classList.remove(value)
      }
      el.classList.add(value)
    }
  }

}

export default FragranceFinder
